package one.healthium.meal_plans.tutorial.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import one.healthium.meal_plans.tutorial.screen.PersonalMealPlanTutorialScreen

@Composable
fun PersonalMealPlanTutorialContent(component: PersonalMealPlanTutorialComponent) {
    CompositionLocalProvider(LocalViewModelStoreOwner provides component) {
        PersonalMealPlanTutorialScreen(component)
    }
}